import React from 'react';
import {Button, ButtonProps} from '@mui/material';
import styled from 'styled-components';

type ActionButtonProps = ButtonProps;

const StyledCancelButton = styled(Button)`
    && {
        font-family: 'Manrope', sans-serif;
        font-weight: 600;
        text-transform: none;
        border-radius: 16px;
    }
`;

const StyledActionButton = styled(Button)`
    && {
        font-family: 'Manrope', sans-serif;
        font-weight: 600;
        text-transform: none;
        border-radius: 16px;
    }
`;

export const CancelButton: React.FC<ActionButtonProps> = ({disabled = false, type = 'button', ...rest}) => {
    return (
        <StyledCancelButton
            disabled={disabled}
            type={type}
            {...rest}
        />
    );
};

export const ActionButton: React.FC<ActionButtonProps> = ({variant = 'contained', color = 'primary', disabled = false, type = 'button', ...rest}) => {
    return (
        <StyledActionButton
            variant={variant}
            color={color}
            disabled={disabled}
            type={type}
            {...rest}
        />
    );
};
